import { ActionHandlerService } from './../../../services/action-handler.service';
import { InfoAction } from 'src/app/model/map-actions/info-action';
import { NavigationAction } from 'src/app/model/map-actions/navigation-action';
import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { SLMap } from 'src/app/model/sl-map';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { Feature } from 'src/app/model/drawing/Feature';
import { ActionGroupComponent } from '../../action-group/action-group.component';
import { ActionGroupEvent } from 'src/app/types/actiongroupevent';
import { EditorAction } from 'src/app/model/map-actions/editor-action';
import { PixoSpatialCoord } from 'src/app/model/Pixospatial';
import { GPSInfo } from 'src/app/types/@types/sl-v-types';
import { StatefulCSS } from 'src/app/model/stateful_css';
import { SlWapiService } from 'src/app/model/api-services/sl-wapi.service';
import { environment } from 'src/environments/environment';
import { info } from 'console';
import { AttributeViewComponent } from '../attribute-view.component';
import { FeatureInfo } from '../../draw-pane/draw-pane.component';

@Component({
  selector: 'app-vertex-tools',
  templateUrl: './vertex-tools.component.html',
  styleUrls: ['./vertex-tools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VertexToolsComponent implements AfterViewInit {
  private gpsState: StatefulCSS;
  public editorReady = false;
  @Input()
  slMap: SLMap;




  @ViewChild('actions', { static: true }) actions: ActionGroupComponent;
  subscriptions = new SubScriptionMgr();
  currentFeature: Feature;
  @Output()
  public geometryChange = new EventEmitter<VertexToolsComponent>();
  notifyEnabled = true;

  public set isEditing(editing: boolean) {
    if (!this.slMap || !this.slMap.component) {
      return;
    }
    const digOn = editing;

    this.slMap.component.ToggleInteraction('digitizing', digOn);

    if (digOn === false) {
      this.slMap.digitizer.TurnOff(false, false);
    } else {
      this.slMap.digitizer.TurnOn(false);
      InfoAction.Exec('query-mode-none', this.slMap.component, {});
    }
    this.slMap.DigitizerUpdated();;
    if (editing) {
      this.slMap.digitizer.drawPane.drawMode = 'feature';
    }
    this.Refresh();
  }

  public get isEditing(): boolean {
    if (!this.slMap || !this.slMap.component || !this.slMap.component.drawPane) {
      return false;
    }

    return this.slMap.component.drawPane.isOn && this.slMap.component.digitizerOn;
  }
  private _scanning: boolean = false;
  public set scanning(isScanning: boolean) {
    //do nothing;
  }
  public get scanning() {

    return EditorAction.geoWatcher !== -1;
  }
  public get showStaticScan(): boolean {
    if ((this.scanning === false) && (this.hasAccuracy === true)) {
      return true;
    }
    return false;
  }
  public get activeScanner(): string {
    if (this.hasAccuracy === false) {
      return '/assets/images/empty.png';
    }
    if (Number(this.accuracy) <= 0) {
      return '/assets/images/scan-unknown-static.png';
    }
    if (Number(this.accuracy) < 10) {
      return '/assets/images/scan-good-static.png';
    } else if (Number(this.accuracy) <= 25) {
      return '/assets/images/scan-warn-static.png';
    } else if (Number(this.accuracy) > 25) {
      return '/assets/images/scan-bad-static.png';
    }
    return '/assets/images/scan-unknown-static.png';

  }
  public get isUpdating(): boolean {
    return !this.isEditing;
  }
  public get vertexSelected(): boolean {
    return this.IsVertexSelected();
  }
  public get geometrySelected(): boolean {
    if (!this.slMap.component || !this.slMap.component.drawPane || !this.slMap.component.drawPane.GetSelectedFeature()) {
      return false;
    }
    if (this.isEditing === false) {
      return false;
    }
    const feature = this.slMap.component.drawPane.GetSelectedFeature()
    const geom = feature.GetSelectedInfo();
    if (!geom) {
      return false;
    }
    return true;
  }
  public get hasGeometry(): boolean {
    if (!this.slMap || !this.slMap.component || !this.slMap.component.drawPane) {
      return false;
    }
    return this.slMap.component.drawPane.hasVertices;
  }

  public get hasAccuracy(): boolean {
    if (!this.slMap || !this.slMap.component || !this.slMap.component.drawPane) {
      return false;
    }
    const feature = this.slMap.component.drawPane.GetSelectedFeature();
    if (!feature || !feature.hasVertices) {
      return false;
    }
    if (this.vertexSelected === false) {
      return false;
    }
    const selected = feature.GetSelectedInfo();
    if (!selected.coord) {
      return false;
    }
    const coord: PixoSpatialCoord = selected.coord as PixoSpatialCoord;
    if (coord.spatial && coord.spatial.accuracy) {
      return true;
    }
    return false;

  }
  public get accuracy(): string {
    if (!this.hasAccuracy) { return '' }
    const feature = this.slMap.component.drawPane.GetSelectedFeature();
    const selected = feature.GetSelectedInfo();
    const coord: PixoSpatialCoord = selected.coord as PixoSpatialCoord;
    if (coord.spatial && coord.spatial.accuracy) {
      return '' + coord.spatial.accuracy.toFixed(0);
    }
    return '';
  }
  public get hasMultipleGeometry(): boolean {
    if (!this.slMap || !this.slMap.component || !this.slMap.component.drawPane) {
      return false;
    }
    return this.slMap.component.drawPane.GetSelectedFeature().geometryCount > 1;
  }

  public get showAdders(): boolean {
    if (!this.slMap || !this.slMap.component || !this.slMap.component.drawPane) {
      return false;
    }
    if (!this.HasDigitizerLayer()) {
      return false;
    }
    const feature = this.slMap.component.drawPane.GetSelectedFeature();
    if (!feature) {
      return false;
    }
    if (!this.hasGeometry) {
      return true;
    }
    if (feature.type === 'point') {
      if (this.hasGeometry) {
        return false;
      }
    }
    return true;

  }
  public get showEditors(): boolean {
    if (!this.slMap || !this.slMap.component || !this.slMap.component.drawPane) {
      return false;
    }
    if (!this.HasDigitizerLayer()) {
      return false;
    }
    const feature = this.slMap.component.drawPane.GetSelectedFeature();
    if (!feature) {
      return false;
    }
    if (!this.hasGeometry) {
      return false;
    }
    return this.geometrySelected;

  }
  public get selectedGeometry(): any {
    if (!this.geometrySelected) {
      return null;
    }
    const feature = this.slMap.component.drawPane.GetSelectedFeature();
    const geom = feature.GetSelectedInfo();
    return geom;
  }

  get hasSelectedGeometry(): boolean {

    return this.geometrySelected === false
  }
  get allowUpdateOrAdd(): boolean {
    if (!this.HasDigitizerLayer()) return false;
    if (this.IsVertexSelected()) return true;
    if (!this.hasGeometry) return true;
    return false;
  }
  constructor(private cdr: ChangeDetectorRef,
    private domNode: ElementRef,
    private actionsSvc: ActionHandlerService) { }

  ngAfterViewInit(): void {
    this.gpsState = new StatefulCSS();
    this.gpsState.SetPrefix('');
    this.gpsState.AddState('good');
    this.gpsState.AddState('bad');
    this.gpsState.AddState('warn');
    this.gpsState.AddState('scanning');
    this.gpsState.AddState('hidden');
    this.gpsState.SetMachine($('.img.editor-gps')[0]);
    this.gpsState.SetState('hidden');
    this.editorReady = true;
    if (!this.slMap) {
      window.requestAnimationFrame(() => { this.ngAfterViewInit() });
      return;
    }
    if (!this.slMap.component || !this.slMap.component.drawPane) {
      window.requestAnimationFrame(() => { this.ngAfterViewInit() });
      return;
    }
    this.subscriptions.Subscribe(this.slMap.digitizer.layerSel.layerChange, () => {
      this.Refresh();
    })
    this.subscriptions.Subscribe(this.slMap.component.drawPane.selectionChange, () => {
      if (this.notifyEnabled === true) {
        // this.geometryChange.emit(this);
      }
      this.Refresh();
    });
    this.subscriptions.Subscribe(this.slMap.component.drawPane.geometryChange, () => {
      if (this.notifyEnabled === true) {
        this.geometryChange.emit(this);
      }
      this.Refresh();
    });
    this.subscriptions.Subscribe(this.actions.actions, (event: ActionGroupEvent) => {
      if (!event.action) return;
      this.HandleGPSAction(event.action);
    });
    this.Refresh();
  }

  get hasPrevGeom(): boolean {
    return this.slMap.digitizer.HasPrevGeom();

  }
  get hasNextGeom(): boolean {
    return this.slMap.digitizer.HasNextGeom();
  }
  NextGeom() {
    if (!this.hasNextGeom) return false;
    this.slMap.digitizer.NextGeom();
    this.Refresh();
  }
  PrevGeom() {
    if (!this.hasPrevGeom) return false;

    this.slMap.digitizer.PrevGeom();
    this.Refresh();
  }
  NewFeature(asNew:boolean = false) {
    EditorAction.NewEditorFeature(this.slMap.component, {hasGeometry:this.hasGeometry,hasLayer:this.HasDigitizerLayer(),asNew:asNew});
  }
  IsVertexSelected(): boolean {
    if (this.HasDigitizerSelection() === false) {
      return false;
    }
    const selFeature = this.slMap.component.drawPane.GetSelectedFeature();
    if (!selFeature) {
      return false;
    }
    const selInfo = selFeature.GetSelectedInfo();
    if (!selInfo) {
      return false;
    }
    return selInfo.type === 'point';
  }
  HasDigitizerSelection(): boolean {
    if (!this.slMap.component || !this.slMap.component.drawPane || !this.slMap.component.drawPane.GetSelectedFeature()) {
      return false;
    }
    const feature = this.slMap.component.drawPane.GetSelectedFeature()
    return (!!feature);
  }
  HasDigitizerLayer(): boolean {
    return this.slMap.digitizer.HasDigitizerLayer();
  }
  DigitizerUpdated() {
    // this.cdr.markForCheck();
    this.Refresh();
  }
  // tslint:disable-next-line: no-shadowed-variable
  GPSUpdate(info: GPSInfo) {
    if (!!info.accuracy) {
      if (info.accuracy < 10) {
        this.gpsState.SetState('good');
      } else if (info.accuracy <= 25) {
        this.gpsState.SetState('warn');
      } else if (info.accuracy > 25) {
        this.gpsState.SetState('bad');
      }
      $('.gps-accuracy').text(info.accuracy.toFixed(0) + 'm');
    }

    this.Refresh();
  }
  GPSAdd() {
    const confirmOptions = [
      {
        name: 'add-vertex',
        label: 'Add point via GPS'
      },
      {
        name: 'move-vertex',
        label: 'Move selected vertex via GPS'
      }
    ]
    if(this.vertexSelected === false) {
      confirmOptions.splice(1,1);
    }
    this.slMap.messager.Confirm(
      'Add or move a point using the options below. Click Cancel to continue editing your feature.',
      (message) => {
        switch (message.option.name) {
          case 'add-vertex':
            this.HandleGPSAction('editor/gps-add-vertex');
            break;
          case 'move-vertex':
            this.HandleGPSAction('editor/gps-update-vertex');
            break;
        }
      }, () => { }, 'Add/Move by GPS', confirmOptions)
  }
  Reset() {
    if (this.slMap && this.slMap.component && this.slMap.component.drawPane) {
      this.slMap.component.drawPane.Clear().NewFeature();
    }
    this.isEditing = false;
    this.Refresh();
  }
  HandleGPSAction(action: string) {
    EditorAction.Exec(action.split('/').pop(), this.slMap.component);
    if (EditorAction.geoWatcher === -1) {
      this.gpsState.SetState('hidden');
    }
    window.requestAnimationFrame(() => {
      this.JumpTo();
    });
    this.Refresh();
  }
  ToggleScanning(event) {
    if (this.scanning === true) {
      EditorAction.StopGPS(this.slMap.component, {});
      if (event.cancelable === true) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      this.Refresh();
    } else {
      NavigationAction.GpsAutoOrient(this.slMap.component);
      this.Refresh();
    }
  }
  DeleteVertex() {
    EditorAction.DeleteVertex(this.slMap.component, {});
    this.Refresh();
  }
  DeleteFeature() {
    EditorAction.DeleteFeature(this.slMap.component, {});
    this.Refresh();
  }

  JumpTo() {
    EditorAction.JumpToGeometry(this.slMap.component);
  }
  Refresh() {
    if (!this.editorReady) return;
    this.cdr.detectChanges();
  }
}
